import { PATH_CONTACTO_DETAIL } from '../../../../navigation/navigation.module';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard-service';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Component({
  selector: 'contactos-dialog',
  templateUrl: './contactos-dialog.component.html',
  styleUrls: ['./contactos-dialog.component.scss']
})
export class ContactosDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  contactosConsignas = [];
  contactosPage = 0;
  PAGE_SIZE: number = 10;

  blockFetch: boolean = false;

  private scrollSubscriber;

  constructor(private dashboardService: DashboardService,
              public dialogRef: MdDialogRef<ContactosDialogComponent>,
              private router: Router) { }

  ngOnInit() {
    this.loadContactos();
  }

  loadContactos() {
    this.dashboardService.getConsignasByContacto(this.contactosPage, this.PAGE_SIZE)
      .subscribe(data => {
        console.log(data);
        this.contactosConsignas = [...this.contactosConsignas, ...data.ResponseData];
        this.blockFetch = false;
      });
  }

  navigateToContacto(contacto){
    this.dialogRef.close();
    this.router.navigate([PATH_CONTACTO_DETAIL, contacto.ContactoId]);    
  }

  ngAfterViewInit(): void {
    const content = document.getElementById('contactos-scroll');
    
    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        let max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7 && !this.blockFetch){
          this.blockFetch = true;
          this.contactosPage++;
          this.loadContactos();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/contactos-dialog/contactos-dialog.component.ts